import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { OneApiAuthInterceptor } from './core/interceptors/interceptor';
import { scheduledReportsMockInterceptor } from './features/customer/reporting-v2/interceptors/scheduled-reports-mock.interceptor';
import { dataHouseMockInterceptor } from './features/customer/data-house/interceptors/data-house-mock.interceptor';
import { pivotMockInterceptor } from './features/customer/inventory/pivot/interceptors/pivot-mock.interceptor';
import { actionableInsightsMockInterceptor } from './features/customer/inventory/interceptors/actionable-insights-mock.interceptor';
import { NotificationService } from '@progress/kendo-angular-notification';
import { IconsService } from '@progress/kendo-angular-icons';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { BarChart, GraphChart, LineChart, PieChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

// Register the required components
echarts.use([
  BarChart,
  // Entity Orbit (AIM pivot prototype) renders as a graph series.
  GraphChart,
  LineChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  CanvasRenderer,
]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom([BrowserAnimationsModule]),
    provideHttpClient(
      withInterceptors([
        scheduledReportsMockInterceptor,
        dataHouseMockInterceptor,
        // PROTOTYPE — AIM pivot. Remove when the real edge endpoints land.
        pivotMockInterceptor,
        actionableInsightsMockInterceptor,
        OneApiAuthInterceptor,
      ])
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false, // Disable dark mode, force light mode
        },
      },
    }),
    NotificationService,
    IconsService,
    provideEchartsCore({ echarts }),
  ],
};
